"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskBimDialog = exports.RiskBimMaps = exports.RiskBimAppContent = exports.MapDragView = exports.MapClickView = void 0;
var React = require("react");
var react_1 = require("react");
var react_leaflet_1 = require("react-leaflet");
var L = require("leaflet");
var proj4_1 = require("proj4");
var riskbimContext_1 = require("../../context/RiskBim/riskbimContext");
var dialog_1 = require("../dialog");
var buttons_1 = require("../buttons");
var MapClickView = function (props) {
    var map = (0, react_leaflet_1.useMapEvents)({
        baselayerchange: function (e) {
            props.onbaseLayerChange(e.name);
        },
        click: function (e) {
            if (props.isPicking) {
                var _a = e.latlng, lat = _a.lat, lng = _a.lng;
                props.onupdateFeatures(props.pickid, {
                    geometry: {
                        coordinates: [lng, lat, undefined]
                    }
                });
                map.eachLayer(function (layer) {
                    if (layer instanceof L.Marker) {
                        if (layer.feature.properties.object_guid === props.pickid) {
                            layer.setLatLng(e.latlng);
                        }
                    }
                });
                map.on('baselayerchange', function () {
                    map.eachLayer(function (layer) {
                        if (layer instanceof L.Marker) {
                            if (layer.feature.properties.object_guid === props.pickid) {
                                layer.setLatLng(e.latlng);
                            }
                        }
                    });
                });
                map.setView([lat, lng], map.getZoom());
            }
        }
    });
    return React.createElement(React.Fragment, null);
};
exports.MapClickView = MapClickView;
var ChangeView = function (props) {
    var map = (0, react_leaflet_1.useMap)();
    if (props.updated_marker !== null && props.all_risks_controls) {
        var baseUrl = '/static/img/';
        var iconUrl = baseUrl + 'marker-icon.png';
        var className = 'map-marker';
        var shadowUrl = baseUrl + 'marker-shadow.png';
        map.eachLayer(function (layer) {
            if (layer instanceof L.Marker) {
                if (layer.feature.properties.object_guid === props.updated_marker.properties.object_guid) {
                    var model = props.models.filter(function (model) {
                        return model.value == String(props.updated_marker.properties.model_to_use);
                    })[0];
                    if (model && model.value !== '') {
                        iconUrl = baseUrl + 'bim_model_' + props.updated_marker.properties.model_to_use + '.png';
                    }
                    if (model && model.value == '') {
                        if (props.updated_marker.properties.object_type === 'risk') {
                            iconUrl = baseUrl + 'bim_model_' + props.project_settings.default_risk_model + '.png';
                        }
                        else {
                            iconUrl = baseUrl + 'bim_model_' + props.project_settings.default_control_model + '.png';
                        }
                    }
                    var icon = layer.getIcon();
                    icon.options.iconUrl = iconUrl;
                    layer.setIcon(icon);
                    layer.setLatLng([props.updated_marker.geometry.coordinates[1], props.updated_marker.geometry.coordinates[0]]);
                }
            }
        });
        map.on('baselayerchange', function (e) {
            map.eachLayer(function (layer) {
                if (layer instanceof L.Marker) {
                    if (layer.feature.properties.object_guid === props.updated_marker.properties.object_guid) {
                        var model = props.models.filter(function (model) {
                            return model.value == String(props.updated_marker.properties.model_to_use);
                        })[0];
                        if (model && model.value !== '') {
                            iconUrl = baseUrl + 'bim_model_' + props.updated_marker.properties.model_to_use + '.png';
                        }
                        if (model && model.value == '') {
                            if (props.updated_marker.properties.object_type === 'risk') {
                                iconUrl = baseUrl + 'bim_model_' + props.project_settings.default_risk_model + '.png';
                            }
                            else {
                                iconUrl = baseUrl + 'bim_model_' + props.project_settings.default_control_model + '.png';
                            }
                        }
                        var icon = layer.getIcon();
                        icon.options.iconUrl = iconUrl;
                        layer.setIcon(icon);
                        layer.setLatLng([props.updated_marker.geometry.coordinates[1], props.updated_marker.geometry.coordinates[0]]);
                    }
                }
            });
        });
    }
    map.setView(props.center, map.getZoom());
    return React.createElement(React.Fragment, null);
};
var MapDragView = function (props) {
    var map = (0, react_leaflet_1.useMapEvents)({
        dragend: function () {
            var center = map.getCenter();
            props.onCenterChange([center.lat, center.lng]);
        },
    });
    return React.createElement(React.Fragment, null);
};
exports.MapDragView = MapDragView;
var RiskBimApp = function (props) {
    return (React.createElement(riskbimContext_1.RiskBimContextProvider, { project_id: props.project_id, type_id: props.type_id, type: props.type },
        React.createElement(RiskBimAppContent, { type: props.type })));
};
exports.default = RiskBimApp;
var RiskBimAppContent = (function (_super) {
    __extends(RiskBimAppContent, _super);
    function RiskBimAppContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RiskBimAppContent.prototype.componentDidMount = function () {
        this.context.fetchAll();
    };
    RiskBimAppContent.prototype.render = function () {
        var _this = this;
        return (React.createElement(riskbimContext_1.default.Consumer, null, function (context) {
            return React.createElement("div", null,
                context.type_id !== undefined &&
                    React.createElement(buttons_1.ActionButton, { className: "BIMLocationCellButton", onClick: context.openDialog },
                        gettext("Map"), "(".concat(context.locations_count, ")")),
                React.createElement(exports.RiskBimDialog, { type: _this.props.type }));
        }));
    };
    RiskBimAppContent.contextType = riskbimContext_1.default;
    return RiskBimAppContent;
}(React.Component));
exports.RiskBimAppContent = RiskBimAppContent;
var RiskBimMaps = function (props) {
    var _a, _b, _c;
    var contextValue = (0, react_1.useContext)(riskbimContext_1.default);
    var createMarkerWithIcon = function (latlng, icon) {
        var map = (0, react_leaflet_1.useMap)();
        var self = _this;
        if (props.all_risks_controls) {
            var marker = L.marker(latlng, { icon: icon, draggable: false });
        }
        else {
            var marker = L.marker(latlng, { icon: icon, draggable: true });
        }
        marker.on('click', function (event) {
            map.setView(event.target.getLatLng(), map.getZoom());
            contextValue.onMarkerClick(event.target.feature);
        });
        marker.on('dragend', function (event) {
            var latlng = event.target.getLatLng();
            var latitude = latlng.lat;
            var longitude = latlng.lng;
            var pickid = event.target.feature.properties.object_guid;
            contextValue.onUpdateFeature(pickid, {
                geometry: {
                    coordinates: [longitude, latitude, undefined]
                }
            });
        });
        return marker;
    };
    var onEachFeature = function (feature, layer) {
        var featuresMap = {};
        var name = "";
        if (feature.properties && feature.properties.object_id && feature.properties.object_type) {
            name = name + ' <a href="' + feature.properties.object_link + '" target="_blank">' + '<span style="text-transform:capitalize;">' + feature.properties.object_type + " #" + feature.properties.object_id + ": " + "</span> " + "</a>";
        }
        if (feature.properties && feature.properties.object_title) {
            name = name + "<i>" + feature.properties.object_title + "</i>";
        }
        name = name + "<br />";
        if (feature.properties && feature.properties.id) {
            name = name + "Location #" + feature.properties.id + ": ";
        }
        if (feature.properties && feature.properties.title) {
            name = name + "<i>" + feature.properties.title + "</i>";
        }
        if (feature.properties && feature.properties.object_status) {
            name = name + "<br />Status: <i>" + feature.properties.object_status + "</i>";
        }
        if (feature.properties) {
            var model = props.models.filter(function (model) {
                return model.value == String(feature.properties.model_to_use);
            })[0];
            name = name + "<br />BIM model: <i>" + model.display_name + "</i>";
        }
        var rotation = "";
        if (feature.properties && feature.properties.object_rotation) {
            var rot = parseInt(String(feature.properties.object_rotation));
            if (!(isNaN(rot))) {
                rotation = "<br />rotation " + rot + " &deg;";
            }
        }
        layer.bindPopup("<b>" + name + "</b><i>" + rotation + "</i>");
        if (typeof featuresMap[feature.properties.object_guid] === 'undefined') {
            featuresMap[feature.properties.object_guid] = [];
        }
        featuresMap[feature.properties.object_guid].push(layer);
    };
    var pointToLayerStatus = function (point, latlng) {
        var colour = '';
        if (point.properties.colour_by !== null) {
            colour = point.properties.colour_by;
        }
        var baseUrl = '/static/img/';
        var iconUrl = baseUrl + 'marker-icon.png';
        var shadowUrl = baseUrl + 'marker-shadow.png';
        var className = 'map-marker';
        var model = props.models.filter(function (model) {
            return model.value == String(point.properties.model_to_use);
        })[0];
        if (colour) {
            className = 'map-marker-' + colour.toLowerCase();
        }
        iconUrl = baseUrl + 'risk-icon.png';
        if (model && model.value !== '') {
            iconUrl = baseUrl + 'bim_model_' + point.properties.model_to_use + '.png';
        }
        if (model && model.value == '') {
            if (point.properties.object_type === 'risk') {
                iconUrl = baseUrl + 'bim_model_' + props.project_settings.default_risk_model + '.png';
            }
            else {
                iconUrl = baseUrl + 'bim_model_' + props.project_settings.default_control_model + '.png';
            }
        }
        shadowUrl = undefined;
        var icon = L.icon({
            iconUrl: iconUrl,
            shadowUrl: shadowUrl,
            className: className,
            iconAnchor: [12, 41],
            shadowAnchor: [12, 41],
            popupAnchor: [0, -31]
        });
        return createMarkerWithIcon(latlng, icon);
    };
    var pointToLayerRiskLevel = function (point, latlng) {
        var color = '#3388ff';
        var className = 'map-marker';
        var baseUrl = '/static/img/';
        var iconUrl = baseUrl + 'marker-icon.png';
        var shadowUrl = baseUrl + 'marker-shadow.png';
        var model = props.models.filter(function (model) {
            return model.value == String(point.properties.model_to_use);
        })[0];
        if (point.properties.object_type === 'Risk' || point.properties.object_type === 'risk') {
            var risk_level_color = point.properties.object_risk_level_worst_by_color;
            if (risk_level_color) {
                risk_level_color = risk_level_color.toLowerCase();
                if (risk_level_color === 'white') {
                    className = '';
                }
                else if (risk_level_color === 'red') {
                    className = 'map-marker-red';
                }
                else if (risk_level_color === 'orange') {
                    className = 'map-marker-orange';
                }
                else if (risk_level_color === 'yellow') {
                    className = 'map-marker-yellow';
                }
                else if (risk_level_color === 'green') {
                    className = 'map-marker-green';
                }
                else {
                    color = risk_level_color;
                }
            }
            iconUrl = baseUrl + 'risk-icon.png';
            if (model && model.value !== '') {
                iconUrl = baseUrl + 'bim_model_' + point.properties.model_to_use + '.png';
            }
            if (model && model.value === '') {
                iconUrl = baseUrl + 'bim_model_' + props.project_settings.default_risk_model + '.png';
            }
            shadowUrl = undefined;
        }
        else {
            iconUrl = baseUrl + 'control-icon.png';
            if (model && model.value !== '') {
                iconUrl = baseUrl + 'bim_model_' + point.properties.model_to_use + '.png';
            }
            if (model && model.value == '') {
                iconUrl = baseUrl + 'bim_model_' + props.project_settings.default_control_model + '.png';
            }
            shadowUrl = undefined;
        }
        var tintAction = "function(r, g, b, a) {return tint([r, g, b, a], '".concat(color, "', 1)}");
        var markerHtml = "<span>\n    <img src=\"".concat(iconUrl, "\" alt=\"Marker icon\" onload=\"processPixels(this, ").concat(tintAction, ")\">\n</span>");
        var icon = L.divIcon({
            className: className,
            html: markerHtml,
            iconUrl: iconUrl,
            shadowUrl: shadowUrl,
            iconAnchor: [12, 41],
            shadowAnchor: [12, 41],
            popupAnchor: [0, -31]
        });
        return createMarkerWithIcon(latlng, icon);
    };
    var changeCoordinateSystem = function (row) {
        props.coordinate_systems.map(function (choice, index) {
            proj4_1.default.defs("EPSG:" + choice.espg, choice.definition_string);
        });
        var coords = (0, proj4_1.default)('EPSG:' + props.selectedCoordinate, 'EPSG:4326', [row.geometry.coordinates[0], row.geometry.coordinates[1]]);
        row.geometry.coordinates[1] = coords[1];
        row.geometry.coordinates[0] = coords[0];
        return row;
    };
    var onRowClick = function (row) {
        row = changeCoordinateSystem(row);
        contextValue.onMarkerClick(row);
    };
    var updateRow = function (row, field, e) {
        e.stopPropagation();
        var value = e.target.value;
        if (field === 'title' || field === 'object_rotation' || field === 'model_to_use') {
            row.properties[field] = value;
        }
        if (field === 'Lat') {
            row.geometry.coordinates[1] = Number(value);
        }
        else if (field === 'Long') {
            row.geometry.coordinates[0] = Number(value);
        }
        else if (field === 'zoom') {
            if (value.toString().match(/\d,\d/)) {
                value = value.toString().replace(",", ".");
            }
            row.geometry.coordinates[2] = Number(value);
        }
        if (props.project_settings !== undefined) {
            row = changeCoordinateSystem(row);
        }
        contextValue.onUpdateFeature(row.properties.object_guid, {
            geometry: {
                coordinates: [Number(row.geometry.coordinates[0]), Number(row.geometry.coordinates[1]), Number(row.geometry.coordinates[2])]
            },
            properties: {
                title: row.properties.title,
                object_rotation: row.properties.object_rotation,
                model_to_use: row.properties.model_to_use
            }
        });
    };
    var updateRows = function (feature) {
        props.coordinate_systems.map(function (choice, index) {
            proj4_1.default.defs("EPSG:" + choice.espg, choice.definition_string);
        });
        var lat = feature.geometry.coordinates[1];
        var long = feature.geometry.coordinates[0];
        var coords = [long, lat];
        if (props.selectedCoordinate !== null) {
            coords = (0, proj4_1.default)('EPSG:4326', 'EPSG:' + props.selectedCoordinate, [long, lat]);
        }
        feature.geometry.coordinates[0] = coords[0];
        feature.geometry.coordinates[1] = coords[1];
        return feature;
    };
    var onIncrement = function (row, field, e) {
        e.stopPropagation();
        if (field === 'Lat') {
            row.geometry.coordinates[1] += 1;
        }
        else if (field === 'Long') {
            row.geometry.coordinates[0] += 1;
        }
        else if (field === 'zoom') {
            row.geometry.coordinates[2] += 1;
        }
        else if (field === 'object_rotation') {
            row.properties.object_rotation += 1;
        }
        if (props.project_settings !== undefined) {
            row = changeCoordinateSystem(row);
        }
        contextValue.onUpdateFeature(row.properties.object_guid, {
            geometry: {
                coordinates: [Number(row.geometry.coordinates[0]), Number(row.geometry.coordinates[1]), Number(row.geometry.coordinates[2])]
            },
            properties: {
                title: row.properties.title,
                object_rotation: row.properties.object_rotation,
                model_to_use: row.properties.model_to_use
            }
        });
    };
    var onDecrement = function (row, field, e) {
        e.stopPropagation();
        if (field === 'Lat') {
            row.geometry.coordinates[1] -= 1;
        }
        else if (field === 'Long') {
            row.geometry.coordinates[0] -= 1;
        }
        else if (field === 'zoom') {
            row.geometry.coordinates[2] -= 1;
        }
        else if (field === 'object_rotation') {
            row.properties.object_rotation -= 1;
        }
        if (props.project_settings !== undefined) {
            row = changeCoordinateSystem(row);
        }
        contextValue.onUpdateFeature(row.properties.object_guid, {
            geometry: {
                coordinates: [Number(row.geometry.coordinates[0]), Number(row.geometry.coordinates[1]), Number(row.geometry.coordinates[2])]
            },
            properties: {
                title: row.properties.title,
                object_rotation: row.properties.object_rotation,
                model_to_use: row.properties.model_to_use
            }
        });
    };
    var headers = [
        { id: "id", text: gettext("Id"), type: "label" },
        { id: "title", text: gettext("Title"), type: "text" },
        { id: "latitude", text: pgettext("Short for 'Latitude'", "Lat"), type: "number" },
        { id: "longitude", text: pgettext("Short for 'Longitude'", "Lon"), type: "number" },
        { id: "z", text: 'Z', type: "number" },
        { id: "rotation", text: pgettext("Short for 'Rotation'", "Rot"), type: "number" },
        { id: "model", text: gettext("Model"), type: "model" }
    ];
    return (React.createElement("div", { className: "risk-bim-maps" },
        !props.all_risks_controls &&
            React.createElement("div", { className: "lightbox_info" },
                React.createElement("table", { className: "risk_info" },
                    React.createElement("tbody", null,
                        props.info.confidential !== '' && props.info.type === 'risk' &&
                            React.createElement("tr", null,
                                React.createElement("td", null,
                                    React.createElement("b", null,
                                        gettext("Confidential"),
                                        ":")),
                                React.createElement("td", null, props.info.confidential)),
                        props.info.description !== '' &&
                            React.createElement("tr", null,
                                React.createElement("td", null,
                                    React.createElement("b", null,
                                        gettext("Description"),
                                        ":")),
                                React.createElement("td", null, props.info.description)),
                        ((_a = props.info.tags) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                            React.createElement("tr", null,
                                React.createElement("td", null,
                                    React.createElement("b", null,
                                        gettext("Tags"),
                                        ":")),
                                React.createElement("td", null, props.info.tags.map(function (tag, index) {
                                    return React.createElement("span", { key: index }, (index ? ', ' : '') + tag);
                                }))),
                        props.info.type === 'risk' && ((_b = props.info.cause) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                            React.createElement("tr", null,
                                React.createElement("td", null,
                                    React.createElement("b", null,
                                        gettext("Cause"),
                                        ":")),
                                React.createElement("td", null, props.info.cause.map(function (cause, index) {
                                    return React.createElement("span", { key: index }, (index ? ', ' : '') + cause);
                                }))),
                        props.info.type === 'risk' && ((_c = props.info.effect) === null || _c === void 0 ? void 0 : _c.length) > 0 &&
                            React.createElement("tr", null,
                                React.createElement("td", null,
                                    React.createElement("b", null,
                                        gettext("Effect"),
                                        ":")),
                                React.createElement("td", null, props.info.effect.map(function (effect, index) {
                                    return React.createElement("span", { key: index }, (index ? ', ' : '') + effect);
                                }))),
                        props.info.type === 'risk' && props.info.notes_description !== '' &&
                            React.createElement("tr", null,
                                React.createElement("td", null,
                                    React.createElement("b", null,
                                        gettext("Notes"),
                                        ":")),
                                React.createElement("td", null, props.info.notes_description))))),
        React.createElement(react_leaflet_1.MapContainer, { style: { height: "500px" }, center: props.center, zoom: 13, scrollWheelZoom: false },
            React.createElement(react_leaflet_1.LayersControl, { position: "topright" },
                React.createElement(react_leaflet_1.TileLayer, { attribution: '\u00A9 <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>', url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }),
                React.createElement(react_leaflet_1.LayersControl.BaseLayer, { checked: true, name: "Risk Level" },
                    React.createElement(react_leaflet_1.LayerGroup, null, props.geodata.map(function (feature, index) { return (React.createElement(react_leaflet_1.GeoJSON, { key: index, data: feature, onEachFeature: onEachFeature.bind(_this), pointToLayer: pointToLayerRiskLevel.bind(_this) })); }))),
                React.createElement(react_leaflet_1.LayersControl.BaseLayer, { name: "Status" },
                    React.createElement(react_leaflet_1.LayerGroup, null, props.geodata.map(function (feature, index) { return (React.createElement(react_leaflet_1.GeoJSON, { key: index, data: feature, onEachFeature: onEachFeature.bind(_this), pointToLayer: pointToLayerStatus.bind(_this) })); })))),
            React.createElement(exports.MapClickView, { pickid: props.pickid, isPicking: props.isPicking, markers: props.geodata, onupdateFeatures: contextValue.onUpdateFeature, onbaseLayerChange: contextValue.onBaseLayerChange }),
            React.createElement(ChangeView, { center: props.center, updated_marker: props.updated_marker, base_layer: props.base_layer, models: props.models, project_settings: props.project_settings, all_risks_controls: props.all_risks_controls }),
            React.createElement(exports.MapDragView, { onCenterChange: contextValue.onCenterChange })),
        !props.all_risks_controls &&
            React.createElement("div", { className: "location-table-div mt-5" },
                React.createElement("div", { className: "row mb-2" },
                    React.createElement("div", { className: "col-md-3 offset-md-2" },
                        React.createElement("select", { id: "bim_coordinates", className: "form-control", onChange: function (e) { return contextValue.onChangeCoordinate(parseInt(e.target.value)); } }, props.coordinate_systems.map(function (choice) {
                            return React.createElement("option", { key: choice.espg, value: choice.espg, selected: props.project_settings.default_coordinate_system === choice.espg }, choice.name);
                        }))),
                    React.createElement("div", { className: "col-md-3" },
                        React.createElement("button", { className: "btn btn-cancel ml-5", onClick: contextValue.onAdd }, gettext("Add a new location"))),
                    React.createElement("div", { className: "col-md-2" },
                        React.createElement("button", { className: "btn btn-cancel", disabled: !props.isGeoJsonValid || props.geodata.length < 0, onClick: contextValue.onSave }, gettext("Save locations")))),
                React.createElement("table", { className: "location_table EditableList table table-bordered" },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            headers.map(function (value, index) { return (React.createElement("th", { key: index, className: 'col_' + value.id }, value.text)); }),
                            React.createElement("th", null, "Action"))),
                    React.createElement("tbody", null, props.geodata.map(function (feature, index) {
                        var new_feature = JSON.parse(JSON.stringify(feature));
                        var place = updateRows(new_feature);
                        return (React.createElement("tr", { className: (props.selectedRow && props.pickid === place.properties.object_guid ? 'selected-row' : ''), onClick: function (e) { return onRowClick(place); }, key: index },
                            React.createElement("td", { className: "col_id" }, place.properties.id),
                            React.createElement("td", null,
                                React.createElement("input", { className: "pointer", type: "text", value: place.properties.title, onChange: function (e) { return updateRow(place, 'title', e); } })),
                            React.createElement("td", { className: "col_latitude" },
                                React.createElement("div", { className: "controlbutton" },
                                    React.createElement("div", { className: "buttons" },
                                        React.createElement("button", { onClick: function (e) { return onDecrement(place, 'Lat', e); } }, "-"),
                                        React.createElement("button", { onClick: function (e) { return onIncrement(place, 'Lat', e); } }, "+")),
                                    React.createElement("input", { type: "text", value: place.geometry.coordinates[1], onChange: function (e) { return updateRow(place, 'Lat', e); } }))),
                            React.createElement("td", { className: "col_longitude" },
                                React.createElement("div", { className: "controlbutton" },
                                    React.createElement("div", { className: "buttons" },
                                        React.createElement("button", { onClick: function (e) { return onDecrement(place, 'Long', e); } }, "-"),
                                        React.createElement("button", { onClick: function (e) { return onIncrement(place, 'Long', e); } }, "+")),
                                    React.createElement("input", { type: "text", value: place.geometry.coordinates[0], onChange: function (e) { return updateRow(place, 'Long', e); } }))),
                            React.createElement("td", { className: "col_z" },
                                React.createElement("div", { className: "controlbutton" },
                                    React.createElement("div", { className: "buttons" },
                                        React.createElement("button", { onClick: function (e) { return onDecrement(place, 'zoom', e); } }, "-"),
                                        React.createElement("button", { onClick: function (e) { return onIncrement(place, 'zoom', e); } }, "+")),
                                    React.createElement("input", { type: "text", value: place.geometry.coordinates[2], onChange: function (e) { return updateRow(place, 'zoom', e); } }))),
                            React.createElement("td", { className: "col_rotation" },
                                React.createElement("div", { className: "controlbutton" },
                                    React.createElement("div", { className: "buttons" },
                                        React.createElement("button", { onClick: function (e) { return onDecrement(place, 'object_rotation', e); } }, "-"),
                                        React.createElement("button", { onClick: function (e) { return onIncrement(place, 'object_rotation', e); } }, "+")),
                                    React.createElement("input", { type: "text", value: place.properties.object_rotation, onChange: function (e) { return updateRow(place, 'object_rotation', e); } }))),
                            React.createElement("td", null,
                                React.createElement("select", { key: place.properties.id, id: "bim_model", className: "form-control", onChange: function (e) { return updateRow(place, 'model_to_use', e); } }, props.models.map(function (choice) {
                                    return React.createElement("option", { key: choice.value, value: choice.value, selected: String(place.properties.model_to_use) === choice.value }, choice.display_name);
                                }))),
                            React.createElement("td", { className: "col_actions text-nowrap" },
                                React.createElement("button", { className: "btn btn-primary mr-1", onClick: function () { return contextValue.onPick(place.properties.object_guid); } }, gettext("Pick")),
                                React.createElement("button", { className: "btn btn-cancel", onClick: function () { return contextValue.onDelete(place); } }, gettext("Delete")))));
                    }))))));
};
exports.RiskBimMaps = RiskBimMaps;
var RiskBimDialog = function (props) {
    return (React.createElement(riskbimContext_1.default.Consumer, null, function (context) {
        var dialog_label = context.info.type === '' ? (props.type === "riskcontrol" ? "Risk & control Locations" : props.type.charAt(0).toUpperCase() + props.type.slice(1) + " Locations") : props.type.charAt(0).toUpperCase() + props.type.slice(1) + " locations for " + props.type + " #" + context.info.object_id + " - " + context.info.object_title;
        return (React.createElement(dialog_1.Dialog, { isOpen: context.isOpen, isReady: context.isReady, contentLabel: dialog_label, shouldCloseOnOverlayClick: true, onClose: context.closeDialog, forcedWidth: "1200px" },
            React.createElement(exports.RiskBimMaps, { project_settings: context.project_settings, geodata: context.geodata, info: context.info, models: context.models, coordinate_systems: context.coordinate_systems, pickid: context.pickid, isPicking: context.isPicking, selectedRow: context.selectedRow, selectedCoordinate: context.selectedCoordinate, isGeoJsonValid: context.isGeoJsonValid, center: context.center, all_risks_controls: context.all_risks_controls, updated_marker: context.updated_marker, base_layer: context.base_layer })));
    }));
};
exports.RiskBimDialog = RiskBimDialog;
